import { render, staticRenderFns } from "./AboutUserView.vue?vue&type=template&id=75e3aa4c&scoped=true"
import script from "./AboutUserView.vue?vue&type=script&lang=js"
export * from "./AboutUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e3aa4c",
  null
  
)

export default component.exports